import React from 'react';
import {
  SportsHandball as BadmintonIcon,
  SportsCricket as CricketIcon,
  SportsHockey as IceHockeyIcon,
  SportsTennis as TennisIcon,
  SportsSoccer as FootballIcon,
  Sports as AthleticsIcon,
  Sports as SportsIcon,
} from '@mui/icons-material';

export const getSportIcon = (sport: string, size = 40) => {
  const sx = { fontSize: size };
  switch (sport.toLowerCase()) {
    case 'badminton':
      return <BadmintonIcon sx={sx} />;
    case 'cricket':
      return <CricketIcon sx={sx} />;
    case 'tennis':
      return <TennisIcon sx={sx} />;
    case 'football':
      return <FootballIcon sx={sx} />;
    case 'ice hockey':
      return <IceHockeyIcon sx={sx} />;
    case 'athletics':
      return <AthleticsIcon sx={sx} />;
    default:
      return <SportsIcon sx={sx} />;
  }
};

export const getSportTheme = (sport: string) => {
  switch (sport.toLowerCase()) {
    case 'badminton':
      return { main: '#1565c0', light: '#e3f2fd', border: '#90caf9', gradient: 'linear-gradient(135deg, #e3f2fd 0%, #ffffff 60%, #dbeafe 100%)' };
    case 'cricket':
      return { main: '#2e7d32', light: '#e8f5e9', border: '#a5d6a7', gradient: 'linear-gradient(135deg, #e8f5e9 0%, #ffffff 60%, #dcfce7 100%)' };
    case 'tennis':
      return { main: '#827717', light: '#f9fbe7', border: '#dce775', gradient: 'linear-gradient(135deg, #f9fbe7 0%, #ffffff 60%, #fef9c3 100%)' };
    case 'football':
      return { main: '#00897b', light: '#e0f2f1', border: '#80cbc4', gradient: 'linear-gradient(135deg, #e0f2f1 0%, #ffffff 60%, #ccfbf1 100%)' };
    case 'ice hockey':
      return { main: '#5e35b1', light: '#ede7f6', border: '#b39ddb', gradient: 'linear-gradient(135deg, #ede7f6 0%, #ffffff 60%, #e9d5ff 100%)' };
    case 'athletics':
      return { main: '#ef6c00', light: '#fff3e0', border: '#ffcc80', gradient: 'linear-gradient(135deg, #fff3e0 0%, #ffffff 60%, #ffedd5 100%)' };
    default:
      return { main: '#1976d2', light: '#e3f2fd', border: '#90caf9', gradient: 'linear-gradient(135deg, #e3f2fd 0%, #ffffff 60%, #dbeafe 100%)' };
  }
};
